import BWAccordion from 'components/shared/BWAccordion/index';
import FormEditorQuill from 'components/shared/BWFormControl/FormEditorQuill';
import React from 'react';

const JobApplicationProfileEn = ({ disabled, title, id }) => {
  return (
    <BWAccordion title={title} id={id} isRequired>
      <FormEditorQuill
        field='request_profile_en'
        disabled={disabled}
        validation={{
          required: 'Nội dung là bắt buộc',
        }}
      />
    </BWAccordion>
  );
};

export default JobApplicationProfileEn;
